import React, { useEffect, useState, useRef } from "react";
import { Card, Row, Col, Typography, Tag, Button, message } from "antd";
import { VideoCameraOutlined, PlayCircleOutlined } from "@ant-design/icons";
import axiosInstance from "../../configs";
import JSMpeg from "jsmpeg";

const { Title, Text } = Typography;

export default function CCTVMonitoring() {
    const [cameras, setCameras] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCameras();
    }, []);

    const fetchCameras = async () => {
        try {
            const res = await axiosInstance.get("/cctv");
            setCameras(res.data);
        } catch (err) {
            console.error(err);
            message.error("Gagal memuat daftar CCTV");
        }
    };

    const handleStartStream = async (cam) => {
        try {
            message.loading({ content: "Menghubungkan ke CCTV...", key: "stream" });
            await axiosInstance.post(`/cctv/start/${cam.id}`);

            const canvas = document.getElementById(`video-canvas-${cam.id}`);
            const url = `ws://${window.location.hostname}:${cam.wsPort}`;

            if (canvas) {
                new JSMpeg.Player(url, {
                    canvas: canvas,
                    autoplay: true,
                    audio: false,
                });
            }

            message.success({ content: "Terhubung!", key: "stream" });
        } catch (err) {
            console.error(err);
            message.error({ content: "Gagal menghubungkan stream", key: "stream" });
        }
    };

    return (
        <div className="p-4">
            <Card>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <Title level={3} style={{ margin: 0 }}>
                        <VideoCameraOutlined className="mr-2" />
                        Monitoring CCTV
                    </Title>
                    <Tag color="blue">{cameras.length} Kamera Terdeteksi</Tag>
                </div>

                <Row gutter={[16, 16]}>
                    {cameras.map((cam) => (
                        <Col xs={24} md={12} lg={8} key={cam.id}>
                            <Card
                                hoverable
                                bodyStyle={{ padding: 0 }}
                                actions={[
                                    <Button type="link" icon={<PlayCircleOutlined />} onClick={() => handleStartStream(cam)}>
                                        Mulai Stream
                                    </Button>,
                                ]}
                            >
                                <div style={{ position: "relative", paddingTop: "56.25%", background: "#000" }}>
                                    <canvas
                                        id={`video-canvas-${cam.id}`}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                        }}
                                    />
                                    <div style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        color: "#fff",
                                        pointerEvents: "none",
                                        opacity: 0.5
                                    }}>
                                        <VideoCameraOutlined style={{ fontSize: 48 }} />
                                    </div>
                                </div>
                                <div style={{ padding: 16 }}>
                                    <Card.Meta
                                        title={cam.name}
                                        description={
                                            <div>
                                                <div><Text strong>Lokasi:</Text> {cam.location}</div>
                                                <div className="mt-2">
                                                    <Tag color="green">ONLINE</Tag>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>
        </div>
    );
}
